import { ApplicationState, NEiTThunk } from '..';
import { BeginAjaxCallAction, EndAjaxCallAction } from '../core/actionTypes';
import notification from '../notification';
import { ArchiviActions } from './actionTypes';
import * as archiviazioneApi from './api';
import { FiltroArchivi } from './models';

type Actions = 
ArchiviActions |
    BeginAjaxCallAction |
    EndAjaxCallAction;

export const loadArchiviazioneFiltro = (): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    const state: ApplicationState = getState();
    const refreshCache = state.archivi.filtro.refreshCache;

    archiviazioneApi.getFiltroArchivi(state, refreshCache)
        .then(filtro => {
            dispatch({ type: 'archivi/LOAD_FILTRO', value: filtro });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        })
}

export const loadArchivi = (
    filtro: FiltroArchivi
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });
    
    const state: ApplicationState = getState();
    const refreshCache = state.archivi.archivi.refreshCache;

    archiviazioneApi.getArchivi(state, filtro, refreshCache)
        .then(result => {
            dispatch({ type: 'archivi/LOAD_ARCHIVI', value: result, page: filtro.page });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

export const downloadFile = (
    idArchivio: string
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });
    
    const state: ApplicationState = getState();

    archiviazioneApi.getUrlArchivio(state, idArchivio)
        .then(azureBlobUrl => {
            window.open(azureBlobUrl.url);

            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}